import React, { lazy } from 'react';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Guía Inicio Express',
    desc: 'Cómo usar el sistema desde el primer día. Directo al corazón.',
    value: 4990,
    image: 'https://cdn.magicpatterns.com/uploads/uk7ijSf1anjjq7kbQUzkSN/20260408_2144_Image_Generation_simple_compose_01knqv4221f7pr7y0qywjt353g.png'
  }, {
    num: 2,
    title: 'Checklist Desbloqueo Diario',
    desc: 'Rutina de 5 minutos para empezar cada día desde claridad emocional.',
    value: 5990,
    image: 'https://cdn.magicpatterns.com/uploads/8KobYgFX84QLDSD6LabSup/20260408_2145_Image_Generation_simple_compose_01knqv6bfpfwesg0kk964hb7ct.png'
  }, {
    num: 3,
    title: 'Audio Conexión Profunda',
    desc: 'Audio guiado para reconectarte con vos misma cuando todo parece caos.',
    value: 6990,
    image: 'https://cdn.magicpatterns.com/uploads/b2jZE2VyefkyavDZfVUuMB/20260408_2148_Conexion_y_Calma_simple_compose_01knqvax3yf8ery9jwyp99m052.png'
  }];
  return <section className="w-full px-4 py-6 md:py-10 bg-bonus-light" data-id="element-15">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-16">
        <div className="text-center space-y-1" data-id="element-17">
          <span className="text-bonus font-bold tracking-wider uppercase text-xs" data-id="element-18">
            Incluido sin costo extra
          </span>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main" data-id="element-19">
            3 bonos gratis
          </h2>
        </div>

        <div className="space-y-3" data-id="element-20">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-bonus/30 flex gap-3 items-center" data-id="element-21">
              <div className="flex-shrink-0 w-16 h-22 rounded-lg overflow-hidden border border-bonus/20" data-id="element-22">
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full h-full object-cover" data-id="element-23" />
              </div>
              <div className="flex-grow min-w-0" data-id="element-24">
                <div className="flex items-center justify-between gap-2" data-id="element-25">
                  <h3 className="text-sm md:text-base font-bold text-text-main truncate" data-id="element-26">
                    <span className="text-bonus" data-id="element-27">Bono {bonus.num}:</span>{' '}
                    {bonus.title}
                  </h3>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-28">
                    <span className="line-through text-text-muted text-xs" data-id="element-29">
                      <PriceDisplay amount={bonus.value} data-id="element-30" />
                    </span>
                    <span className="text-solution font-bold bg-solution/10 px-1.5 py-0.5 rounded text-xs" data-id="element-31">
                      Gratis
                    </span>
                  </div>
                </div>
                <p className="text-text-muted text-xs md:text-sm leading-snug mt-0.5" data-id="element-32">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}